import type { PhoneLogType } from "@tellescope/tanstack-query";

export interface PhoneLogsFilters {
  /** ms-epoch bounds, passed server-side to Twilio. */
  dateRange?: { from?: number; to?: number };
  /** SMS / Voice — applied client-side over loaded rows. */
  types?: PhoneLogType[];
  /** Twilio direction values — applied client-side. */
  directions?: string[];
  /** Twilio status values — applied client-side. */
  statuses?: string[];
}

export const phoneLogsFiltersAreEqual = (a: PhoneLogsFilters, b: PhoneLogsFilters): boolean =>
  JSON.stringify(a) === JSON.stringify(b);

export const countPhoneLogsActiveFilters = (filters: PhoneLogsFilters): number => {
  let count = 0;
  if (filters.dateRange && (filters.dateRange.from !== undefined || filters.dateRange.to !== undefined)) count++;
  if (filters.types && filters.types.length > 0) count++;
  if (filters.directions && filters.directions.length > 0) count++;
  if (filters.statuses && filters.statuses.length > 0) count++;
  return count;
};
